import MyStaff from "./MyStaff"


const ManageStaff = () => {
    return (
        <MyStaff/>
    )
}

export default ManageStaff